import { Link } from "gatsby"
import React, { useCallback } from "react"
import Reveal from "react-awesome-reveal"
import { keyframes } from "@emotion/react"

const StyledButton = props => {
  let path
  const internal = /^\/(?!\/)/.test(props.path)

  if (props.path && props.path.includes("internal:")) {
    path = props.path.replace("internal:", "")
  } else {
    path = props.path
  }

  let style = "btn animBtn"

  const fadeInUp = keyframes`
    from {
      opacity: 0;
      transform: translateY(5vh);
    }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`

  const extraClass = props.extraClass ? " " + props.extraClass : ""

  const hoverLinkClass = useCallback(e => {
    const cursor = document.querySelector(".cursor-inner")
    cursor.classList.add("linkHover")
  }, [])

  const removehoverLinkClass = useCallback(e => {
    const cursor = document.querySelector(".cursor-inner")
    cursor.classList.remove("linkHover")
  }, [])

  // Use Gatsby Link for internal links, and <a> for others
  if (internal) {
    return (
      <Reveal triggerOnce={true} keyframes={fadeInUp} cascade={true}>
        <Link
          itemProp="url"
          to={path}
          className={style + extraClass}
          onMouseOver={hoverLinkClass}
          onMouseLeave={removehoverLinkClass}
        >
          {props.title}
        </Link>
      </Reveal>
    )
  }

  return (
    <Reveal triggerOnce={true} keyframes={fadeInUp} cascade={true}>
      <a
        href={path}
        className={style + extraClass}
        onMouseOver={hoverLinkClass}
        onMouseLeave={removehoverLinkClass}
        target={"_blank"}
      >
        {props.title}
      </a>
    </Reveal>
  )
}

export default StyledButton
